/** 🔥 all type are based on this Enum */
export const WizardBasketActions = {
  AddItem: 'AddItem',
  Clear: 'Clear',
  Delete: 'Delete',
  Initialize: 'Initialize',
  Loaded: 'Loaded',
  New: 'New',
  RemoveItem: 'RemoveItem',
  Update: 'Update',
  UpdateFromOtherTab: 'UpdateFromOtherTab',
  Saved: 'Saved',
  MetaChanged: 'MetaChanged',
  DisplayResults: 'DisplayResults',
} as const;
Object.freeze(WizardBasketActions);

export type WizardBasketAction = (typeof WizardBasketActions)[keyof typeof WizardBasketActions];
